import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=67cb8f80&scoped=true"
import script from "./rank.vue?vue&type=script&lang=js"
export * from "./rank.vue?vue&type=script&lang=js"
import style0 from "./rank.vue?vue&type=style&index=0&id=67cb8f80&prod&lang=css"
import style1 from "./rank.vue?vue&type=style&index=1&id=67cb8f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb8f80",
  null
  
)

export default component.exports